
<mat-card>
  <mat-card-content>
    <h2 class="mat-h2" align="center">{{data.title}}</h2>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <p align="center">
      {{data.Message}}
      <span *ngIf="data.isFromBrokerMobileApp"> Please click the Back button to get back to Broker Mobile Dashboard.</span>
    </p>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-footer class="alternate-theme" align="center">
        <button *ngIf="data.showCancelButton" class="nh-custom-button" mat-stroked-button (click)="cancelClick()">Cancel</button>
        <button class="nh-custom-button" color="primary" mat-flat-button [mat-dialog-close]="true" *ngIf="!data.isFromBrokerMobileApp">Ok</button>
    </mat-card-footer>
</mat-card>